import {useCallback, useState} from 'react';
import OtpInput from 'react-otp-input';

interface ReactNativeOTPInputsProps {
  numberOfInputs: number;
  handleChange: (otp: string) => void;
  autofillFromClipboard: boolean;
  autofillListenerIntervalMS: number;
  style: object;
  filledStyles?: React.CSSProperties;
  focusStyles: object;
  inputStyles: object;
  errorStyle: boolean;
  inputContainerStyles: object;
  colorVariant?: 'dark';
  useNewInputSizing?: boolean;
}

const getStyles = (colorVariant?: 'dark', useNewInputSizing?: boolean) => {
  switch (colorVariant) {
    case 'dark':
      return {
        containerStyle: 'items-center flex flex-row justify-between max-h-[132px] w-full',
        inputStyle:
          'text-white bg-transparent text-xl font-bold text-center align-middle focus:border-2 w-full h-full rounded-lg border-2',
        inputWrapper: `justify-center align-center w-11 ${useNewInputSizing ? 'h-11' : 'h-14'}`,
      };
    default:
      return {
        containerStyle: 'items-center flex flex-row justify-between max-h-[132px] w-full',
        inputStyle:
          'text-black text-xl font-bold text-center align-middle focus:border-2 w-full h-full rounded-lg border-2',
        inputWrapper: `bg-white w-11 justify-center align-center ${
          useNewInputSizing ? 'h-11' : 'h-14'
        }`,
      };
  }
};

export default function ReactNativeOTPInputs({
  numberOfInputs,
  handleChange,
  filledStyles,
  errorStyle,
  colorVariant,
  useNewInputSizing = false,
}: ReactNativeOTPInputsProps) {
  const [value, setValue] = useState('');
  const borderColor = errorStyle
    ? '#ef4444'
    : filledStyles?.borderColor || colorVariant === 'dark'
      ? '#DDDAD6'
      : '#999999';
  const {inputStyle, inputWrapper, containerStyle} = getStyles(colorVariant, useNewInputSizing);
  const onChange = useCallback(
    (otp: string) => {
      setValue(otp);
      handleChange(otp);
    },
    [handleChange, setValue]
  );

  return (
    <OtpInput
      value={value}
      onChange={onChange}
      numInputs={numberOfInputs}
      containerStyle={containerStyle}
      inputStyle={inputStyle}
      skipDefaultStyles
      shouldAutoFocus
      renderInput={(props, index) => (
        <div className={inputWrapper}>
          <input
            {...props}
            ref={(element) => {
              props.ref(element);
              // Focus on first input if it is empty
              // This is simulating the autoFocus prop on mount
              if (
                index === 0 &&
                (element?.value == '' || element?.value == null || element?.value == undefined)
              ) {
                setTimeout(() => {
                  element?.focus();
                }, 300);
              }
            }}
            pattern='\d{1}'
            type='number'
            inputMode='decimal'
            style={{
              borderColor: props.value && !errorStyle ? '#4890E8' : borderColor,
            }}
          />
        </div>
      )}
    />
  );
}
